/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { IoAdd } from "react-icons/io5";
import { FiBriefcase } from "react-icons/fi";
import "../../pages/Category/Cemetery/Cemetery.scss";
import { getUserRoutes } from "../../services/myRoute.service";
import { useSelector } from "react-redux";
import NoDataFound from "../NoDataFound/NoDataFound";
import { Link } from "react-router-dom";
import SelectRouteIcon from "../../assets/select_route_icon.png";

function SelectRouteModal({
  route,
  setRoute,
  showModal,
  toggle,
  createNewRoute,
  selectRoute,
  showSpinner,
}) {
  const [routepoint, setRoutePoint] = useState([]);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName,
  );
  const isUserLoggedIn = localStorage.getItem("token");

  useEffect(() => {
    if (isUserLoggedIn) {
      fetchUserRoutes();
    }
  }, []);

  // when modal is open
  useEffect(() => {
    if (showModal) {
      fetchUserRoutes();
    }
  }, [showModal]);

  const fetchUserRoutes = async () => {
    if (isUserLoggedIn) {
      try {
        const response = await getUserRoutes({
          userName: userName,
        });
        if (response && response?.status === 200) {
          setRoutePoint(response?.data?.data?.data);
        }
      } catch {}
    }
  };

  const isDisabled = () => {
    if (route?.id === undefined || showSpinner === true) {
      return true;
    }
  };

  const handleOnchange = (id) => {
    setRoute({
      id: id,
    });
  };

  return (
    <Modal
      className="select_route modal-dialog-centered"
      isOpen={showModal}
      toggle={toggle}
    >
      <ModalHeader>
        <div className="select_route_header_section">
          <img src={SelectRouteIcon} alt="" />
          <p className="select_route_heading">Select Route</p>
        </div>
        <p className="select_route_desc">
          Select one of the route or Create a new route.
        </p>
      </ModalHeader>
      <ModalBody>
        <Form className="form">
          {isUserLoggedIn ? (
            <>
              {routepoint?.length === 0 ? (
                <p>No routes created yet.</p>
              ) : routepoint === undefined ? (
                <NoDataFound />
              ) : (
                routepoint?.map((item) => (
                  <FormGroup
                    check
                    key={item?.routeID}
                    style={
                      route?.id === item?.routeID
                        ? {
                            border: "1px solid #FF8028",
                            backgroundColor: "#FF680008",
                          }
                        : {}
                    }
                  >
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={route?.id === item?.routeID}
                        onChange={() => handleOnchange(item?.routeID)}
                        name="myCheckbox"
                      />
                    </Label>
                    <div className="route_list">
                      <Label>{item?.routeName}</Label>
                      <p>{item?.description}</p>
                    </div>
                  </FormGroup>
                ))
              )}
            </>
          ) : (
            <p>
              {" "}
              You want to see your list? Please continue to &nbsp;
              <Link to="/sign-in">Log In</Link>.
            </p>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        {isUserLoggedIn && (
          <Button className="btn create_route" onClick={createNewRoute}>
            <IoAdd size={20} />
            Create a New Route
          </Button>
        )}

        {isUserLoggedIn && (
          <>
            {routepoint?.length > 0 && (
              <Button
                className="btn add_route"
                disabled={isDisabled()}
                onClick={selectRoute}
              >
                {showSpinner === true ? (
                  <Spinner size="sm"></Spinner>
                ) : (
                  <>
                    <FiBriefcase />
                    Add to Route
                  </>
                )}
              </Button>
            )}
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default SelectRouteModal;
